module.exports = __webpack_public_path__ + "img/10014.b4a43e4c.png";